export async function getAllPontuacao(ano, referencia, revisao, token) {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const apiUrl = `https://boanova183129.protheus.cloudtotvs.com.br:4050/rest/avaliacoes_pex/distribuidores?ano=${ano}&referencia=${referencia}&revisao=${revisao}`;

  try {
    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error get pex points all:", error);
  }
}
